import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "leaseType";

const leaseTypeUrl = "/api/machines/LeaseType";

export const leaseTypeLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Lease Type",
    url: leaseTypeUrl,
  }
);
